export enum CookieCategory {
  NECESSARY = 'NECESSARY',
  PREFERENCES = 'PREFERENCES',
  STATISTICS = 'STATISTICS',
  MARKETING = 'MARKETING',
}
